import { render } from "./ArticleNavigation.vue?vue&type=template&id=373326be&scoped=true"
import script from "./ArticleNavigation.vue?vue&type=script&lang=js"
export * from "./ArticleNavigation.vue?vue&type=script&lang=js"

import "./ArticleNavigation.vue?vue&type=style&index=0&id=373326be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373326be"]])

export default __exports__